const maxRetryExceededErrorMessage = `
  Networking error: Please refresh your connection and reload the page. Your changes may not have been saved.`;

export { maxRetryExceededErrorMessage };